import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'wl-gateway-resolution-page',
  templateUrl: './gateway-resolution-page.component.html',
  styleUrls: ['./gateway-resolution-page.component.less'],
})
export class GatewayResolutionPageComponent implements OnInit, OnDestroy {
  itemNum: number | null = null;
  accountingPackageId: number | null = null;
  paymentTypeId: number | null = null;
  ccGatewayId: number | null = null;
  invoiceNum: number | null = null;

  private subscription?: Subscription;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.subscription?.unsubscribe();
    this.subscription = this.route.queryParamMap.subscribe((params: ParamMap) => {
      this.itemNum = this.parseId(params.get('itemNum'));
      this.accountingPackageId = this.parseId(params.get('accountingPackageId'));
      this.paymentTypeId = this.parseId(params.get('paymentTypeId'));
      this.ccGatewayId = this.parseId(params.get('ccGatewayId'));
      this.invoiceNum = this.parseId(params.get('invoiceNum'));
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  private parseId(value: string | null): number | null {
    return value !== null && /^\d+$/.test(value) ? Number(value) : null;
  }
}
